module.exports = __webpack_public_path__ + "img/hermione_punching_draco.7031d3cc.jpg";